import React from "react";
import { useSpring, animated } from "@react-spring/web";

interface ArnhemLogoProps {}

const ArnhemLogo: React.FC<ArnhemLogoProps> = ({}) => {
  // Define the animation for the "drawing" effect
  const drawAnimation = useSpring({
    from: { strokeDashoffset: 1000, fill: "transparent" },
    to: { strokeDashoffset: 0, fill: "white" },
    config: { duration: 2000 },
  });

  return (
    <div
      id="Logo"
      className="fixed bottom-0 right-0 md:bottom-4 md:right-4 w-32 md:w-40 z-20 outline-none select-none"
    >
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 1000 360.9245"
        preserveAspectRatio="xMinYMid meet"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <animated.text
          x="101"
          y="170"
          fontFamily="ABC Favorit, Helvetica, sans-serif"
          fontWeight="300"
          fontSize="133"
          fill="none" // Start with no fill
          stroke="white" // Set stroke color
          strokeWidth="1"
          strokeDasharray="1000"
          style={drawAnimation} // Apply the drawing animation
        >
          museum
        </animated.text>
        <animated.text
          x="436"
          y="260"
          fontFamily="ABC Favorit, Helvetica, sans-serif"
          fontWeight="300"
          fontSize="133"
          fill="none"
          stroke="white"
          strokeWidth="1"
          strokeDasharray="1000"
          style={drawAnimation} // Apply the drawing animation
          transform-origin="100% 50%"
        >
          arnhem
        </animated.text>
      </svg>
    </div>
  );
};

export default ArnhemLogo;
